import loadScript from '../load-script/load-script';
import loadStyle from '../load-style/load-style';
import { FULL_PAGE } from '../../../app/constants';

/**
 * Loads common UI dependencies (scripts and styles) required by the Eval component.
 * In full-page context, only core resources are loaded; sidebar context loads additional switch/share assets.
 *
 * @param {Object} config - The app configuration object
 * @param {string} config.uiCdnUrl - Ancestry UI CDN URL
 * @param {string} config.cdnUrl - Base CDN URL
 * @param {Object} [options] - Additional options
 * @param {string} [options.renderer] - Renderer type ('sidebar' or 'custom')
 * @param {string} [options.flowId] - The flow ID to determine context
 * @returns {Promise<Array>} Resolves when all dependencies are loaded
 */
export default function loadDependencies(config, options) {
	const { uiCdnUrl, cdnUrl } = config;
	const { renderer, flowId = '' } = options || {};
	const fullPageContext = renderer === 'custom' && flowId.includes(FULL_PAGE);

	// Only needs the follow core ui assets in order to bootstrap full-page merge
	const commonResources = [
		loadScript(`${uiCdnUrl}/js/autogrow.js`, false, true),
		loadScript(`${uiCdnUrl}/js/date-validator.js`, false, true),
		loadScript(`${cdnUrl}/ui-static/lib/glue/1.2.0/glue-bundle.js`, false, true)
	];

	if (!fullPageContext) {
		commonResources.push([
			loadStyle(`${uiCdnUrl}/css/switch.css`),
			loadScript(`${uiCdnUrl}/js/switch.js`, false, true),
			loadScript(`${window.location.origin}/sharing/share.js`, true, false) // defer loading since we haven't loaded our React client yet
		]);
	}
	return Promise.all([...commonResources]);
}
